<div style="margin: 35px auto; width: 90%;">

    <div fxLayout="row" fxLayoutAlign="space-between">
        <button mat-raised-button class="add-server" (click)="addOrUpdateServer()"> Add Server </button>

        <mat-form-field appearance="outline" style="width: 300px;">
            <mat-icon *ngIf="!search.value" matSuffix>search</mat-icon>
            <input #search matInput placeholder="Search" autocomplete="off" (keyup)="applyFilter($event.target.value)">
            <mat-icon *ngIf="search.value" matSuffix (click)="search.value=''; load();">close</mat-icon>
        </mat-form-field>
    </div>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
            </ng-container>

            <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef> URL </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.endpoint ? element.url+':'+element.port+'/'+element.endpoint : element.url+':'+element.port }}
                    <button mat-icon-button
                        (click)="openWindow(element.endpoint ? element.url+':'+element.port+'/'+element.endpoint : element.url+':'+element.port)">
                        <mat-icon>open_in_new</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="environment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Environment </th>
                <td mat-cell *matCellDef="let element"> {{ element.environment }} </td>
            </ng-container>

            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> User </th>
                <td mat-cell *matCellDef="let element"> {{ decrypt(element.user) }} </td>
            </ng-container>

            <ng-container matColumnDef="password">
                <th mat-header-cell *matHeaderCellDef> Password </th>
                <td mat-cell *matCellDef="let element">
                    <input [id]="'password-'+i" #password class="password" type="password" disabled
                        [value]="decrypt(element.password)" />

                    <button mat-icon-button (click)="isVisible(password)">
                        <mat-icon>{{ password.type === 'password' ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    <button mat-icon-button (click)="setAsCopied(password)">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'"> Actions </th>
                <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
                    <button mat-icon-button color="primary" (click)="addOrUpdateServer(element)">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="openConfirmDialog(element)">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="isLoading" class="spinner-container">
            <mat-progress-spinner 
                color="primary" 
                mode="indeterminate">
            </mat-progress-spinner>
        </div>

        <div *ngIf="dataSource.filteredData.length == 0 && !isLoading" class="no-records">
            No records found.
        </div>
    </div>
</div>